/*
 * Copyright (c) Worldline 2023.
 */

import {Component, Input, OnInit} from '@angular/core';
import {PopoverMode} from "../../constant/popover-mode";
import {EvidenceContentType} from "../../constant/evidence-content-type";
import {ExternalEvidencePartStatus} from "../../constant/external-evidence-part-status";
import {SharedService} from "../../services/shared.service";
import {PartRight} from "../../constant/part-right";
import {EvidenceService} from "../../services/evidence.service";
import {RootScopeService} from "../../services/rootscope.service";
import {EvidenceUserHelperService} from "../../services/evidence-user-helper.service";
import {FileExtensionService} from "../../services/file-extension.service";
import {HttpService} from "../../http/http.service";

@Component({
    selector: 'app-wl-evidence-part',
    templateUrl: './wl-evidence-part.component.html'
})
export class WlEvidencePartComponent implements OnInit {

    constructor(public rootScope: RootScopeService,
                private sharedService: SharedService,
                private evidenceService: EvidenceService,
                private evidenceUserHelperService: EvidenceUserHelperService,
                private fileExtensionService: FileExtensionService,
                private httpService: HttpService) {
    }

    @Input()
    extevidenceid: any

    @Input()
    part: any

    @Input()
    ids: any

    @Input()
    contenttype: any

    @Input()
    mandatory: any

    @Input()
    evidencetype: any

    @Input()
    num: any

    @Input()
    numpart: any

    openPopoverEvidencePart: any;
    evidenceContentType: any;
    externalEvidencePartStatus: any;
    popoverMode: any;
    inputAcceptedExtension: any;
    editMode: any;
    imageUploaded: any;
    partInStandBy: any;
    partUploadInProgress: any;
    evidenceMsg: any;
    form: any;

    private sessionId: any;
    private signerId: any;
    private evidenceId: any;
    private evidencePartId: any;
    private nbPages: any;
    private temporaryToProcess: any;
    private file: any;

    ngOnInit(): void {
        const that = this;
        //Local variables for ids
        this.sessionId = this.ids.sessionId;
        this.signerId = this.ids.signerId;
        this.evidenceId = this.ids.evidenceId;
        this.evidencePartId = this.part.extEvidencePartId;

        this.nbPages = 1;

        //Allow to show or not a popover
        if (typeof (this.rootScope.get().popoverTable) === 'undefined') {
            this.evidenceUserHelperService.createPopoverTable();
        }

        //Add keys on popover table
        this.evidenceUserHelperService.registerPopoverButton('help-upload_' + this.evidenceId + '-' + this.evidencePartId);

        //Update scope from the rootScope
        this.openPopoverEvidencePart = this.rootScope.get().openPopover;

        //Pass enums constants to html
        this.evidenceContentType = EvidenceContentType;
        this.externalEvidencePartStatus = ExternalEvidencePartStatus;
        this.popoverMode = PopoverMode;

        //If content type requires a file, prepare list of accepted mime types
        if (this.contenttype !== EvidenceContentType.FORM) {
            //Prepare list of available extensions for upload
            for (var i = 0; i < this.evidencetype.mimeTypes.length; i++) {
                this.evidencetype.mimeTypes[i] = this.fileExtensionService.getExtension(this.evidencetype.mimeTypes[i]);
            }
            //String with all accepted extension in the correct format for input
            this.inputAcceptedExtension = this.fileExtensionService.getInputAcceptedExtension(this.evidencetype.mimeTypes);
        }
        //If content type requires formular entries, prepare a json object for data
        else {
            this.form = {};
        }

        //TODO Rewrite forms MTSSIGNBOX-1551
        this.sharedService.on('formLoaded', function (event) {
            console.debug('formLoaded for ' + event.data.evidenceId + '/' + event.data.partId);
            if ((event.data.evidenceId === that) && (event.data.partId === that.evidencePartId)) {

                if (that.part.uploadDate !== null) {

                    that.httpService.getRawData(that.sessionId, that.signerId, that.evidenceId, that.evidencePartId).toPromise().then(
                        function (response) {
                            console.debug('response : ', response);
                            that.form.setData(response);
                        },
                        function (error) {
                            console.warn(error);
                            return null;
                        });

                    that.editMode = false;

                } else {
                    that.editMode = true;
                }
            }
        });

        //To allow or not the part download
        this.temporaryToProcess = false; //For the cropping and the dispatch of the uploaded data
        this.partUploadInProgress = false; // For the spinner loading button
        this.partInStandBy = false; // For buttons enabling/disabling

        this.sharedService.on('partUploaded', function (event) {

            //Part has been upload, check id current evidence is concerned
            if (that.evidenceId === event.data.evidenceId) {
                //Check if part upload is not current part
                if (that.evidencePartId !== event.data.partId) {
                    that.temporaryToProcess = false;
                    that.partUploadInProgress = false;
                    that.partInStandBy = false;
                }
            }
        });

        this.sharedService.on('partUploadInProgress', function (event) {

            //Upload in progress, check if current evidence is concerned
            if (that.evidenceId === event.data.evidenceId) {
                //Check if current part is the uploading part, set spinner
                if (that.evidencePartId === event.data.evidencePartId) {
                    that.partInStandBy = true;
                    that.partUploadInProgress = true;
                    that.temporaryToProcess = false;
                }
                //If part is not concerned, place it in stand by
                else {
                    that.partInStandBy = true;
                    that.partUploadInProgress = false;
                    that.temporaryToProcess = false;
                }
            }
        });

        this.sharedService.on('temporaryToProcess', function (event) {

            console.debug('dong : ' + event.data.evidenceId + ' ' + event.data.evidencePartId);

            //A upload need to be processed by user, check if current evidence is concerned
            if (that.evidenceId === event.data.evidenceId) {
                //If current part need to be processed, display process button
                if (that.evidencePartId === event.data.evidencePartId) {
                    that.temporaryToProcess = true;
                    that.partInStandBy = true;
                    that.partUploadInProgress = false;
                    that.nbPages = event.data.nbPages;

                    that.evidenceService.verifyEvidence(that.sessionId, that.signerId, that.evidenceId, that.evidencePartId, that.nbPages);
                }
                //Current part is not concerned, disable buttons
                else {
                    that.temporaryToProcess = false;
                    that.partInStandBy = true;
                    that.partUploadInProgress = false;
                }
            }
        });

        this.sharedService.on('uploadFailed', function (event) {

            //An upload failed, check if evidence is concerned
            if (that.evidenceId === event.data.evidenceId) {

                that.temporaryToProcess = false;
                that.partUploadInProgress = false;
                that.partInStandBy = false;

                console.debug('upload failed');
            }
        });

        this.checkEvidencePart();

        //If it is possible, show the image
        if (this.part.mimeType !== null) {
            if (this.fileExtensionService.analyser(this.part.mimeType) === PartRight.toDisplay) {
                this.imageUploaded = this.part.uploadDate ?
                    this.rootScope.get().properties.api.url + '/sessions/' + this.sessionId + '/signers/' + this.signerId + '/evidences/' + this.evidenceId + '/' + this.part.extEvidencePartId + '/data/view/#' + Math.random() : '';
            } else { //If not, download the image
                this.imageUploaded = this.part.uploadDate ?
                    this.rootScope.get().properties.api.url + '/sessions/' + this.sessionId + '/signers/' + this.signerId + '/evidences/' + this.evidenceId + '/' + this.part.extEvidencePartId + '/download' : '';
            }
        }
    }

    //Upload form data as file to ws
    //If a null json is received, the submit is aborted
    sendFormData() {
        console.debug('call send data');
        var data = this.form.getJson();

        if (data === null) {
            return;
        }

        this.form.disableEdition();
        this.editMode = false;

        var jsonAsString = JSON.stringify(data);
        this.file = new Blob([jsonAsString], {
            type: 'text/plain'
        });

        // TODO MTSSIGNBOX-1551 rewrite evidence form (send form data)
        // this.uploader.addToQueue(this.file);
        // this.uploader.uploadAll();
    };

    edit() {
        this.form.enableEdition();
        this.editMode = true;
    };

    deleteEvidence() {
        this.evidenceMsg = this.evidenceService.deleteEvidence(this.sessionId, this.signerId, this.evidenceId, this.evidencePartId);
    };

    download(part, url) {
        var fileName = part.fileName;
        var a = document.createElement('a');
        document.body.appendChild(a);
        this.httpService.httpClient.get(url, {
            headers: this.httpService.getHttpOptions()['headers'],
            responseType: 'blob'
        }).toPromise().then(response => {
            a.href = window.URL.createObjectURL(response);
            a.download = fileName;
            a.click();
        })
    };

    uploadEvidenceFile(event: any) {
        const files = event.files;
        const that = this;

        const formData = new FormData();
        formData.append('file', files.item(0), files.item(0).name)
        this.httpService.uploadEvidence(this.sessionId, this.signerId, this.evidenceId, this.evidencePartId, formData).subscribe({
            next: response => {
                //Do not show the popover anymore
                that.evidenceUserHelperService.closeAll();

                that.evidenceMsg = that.evidenceService.onUploadSuccess(response, that.sessionId, that.signerId, that.evidenceId, that.evidencePartId);

                if (that.contenttype === that.evidenceContentType.FORM) {
                    that.form.manageError(that.evidenceMsg);
                }
            },
            error: err => {
                that.part.uploadDate = null;
                console.warn('An error occurred when uploading an evidence');
                console.warn(err);
                that.evidenceMsg = 'error.evidences.upload';
            }
        })
    }

    private checkEvidencePart() {
        const that = this;
        setTimeout(function () {
            console.debug('externalEvidencePartStatus = ' + that.part.externalEvidencePartStatus);
            if (that.part.externalEvidencePartStatus === ExternalEvidencePartStatus.inProgress) {
                that.evidenceService.getEvidencePart(that.sessionId, that.signerId, that.evidenceId, that.evidencePartId);
            }
        }, 5000);
    };
}